exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input.is-invalid {\n  border-color: #f86c6b !important; }\n\ntable.table {\n  table-layout: fixed;\n  word-wrap: break-word; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/components/form-setting/form-system-admin.component.scss
// module id = ../../../../../src/app/components/form-setting/form-system-admin.component.scss
// module chunks = main